(function() {
    'use strict';

    angular.module('machine')
        .controller('MachineListController', MachineListController);

    MachineListController.$inject = ['$state', 'machineDataSrvc', 'machineSrvc', 'notificationSrvc', 'machineMessagesConst', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'machinePermissionsConst', 'filterQuerySrvc'];

    function MachineListController($state, machineDataSrvc, machineSrvc, notificationSrvc, machineMessagesConst, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, machinePermissionsConst, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.machineRows = [];
        self.machineCols = [{
            title: 'Obraz',
            value: 'image',
            type: 'image'
        }, {
            title: 'Nazwa',
            value: 'name',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Model',
            value: 'model',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Typ',
            value: 'type',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = machinePermissionsConst;
        self.searchQuery = {
            name: null,
            model: null,
            type: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getMachine();
        }

        function getMachine(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    name: self.searchQuery.name,
                    model: self.searchQuery.model,
                    type: self.searchQuery.type,
                    ordering: self.searchQuery.ordering
                };
            }
            return machineDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.machineRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getMachine);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.machine.create');
        }

        function onEdit(row) {
            $state.go('layout.machine.update', { pk: row.pk });
        }

        function onDelete(row) {
            return machineSrvc.remove(row.name, row.pk, function(response) {
                notificationSrvc.notification("success", machineMessagesConst.delete);
                lodashService.remove(self.machineRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getMachine();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getMachine();
        }
    }
})();
